import { ImageCell } from '@/components/shared/ImageCell';
import type { Tour } from '@/config/objects/tours';

interface TourImageCellProps {
  tour?: Tour;
  size?: 'sm' | 'lg';
}

/**
 * Editable tour image cell component with upload and delete actions
 */
export function TourImageCell({ tour, size = 'sm' }: TourImageCellProps) {
  return (
    <ImageCell
      item={tour}
      endpoint="/tours"
      entityName="Tour"
      imageLabel="Tour Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
